export default function Footer() {
    return (<footer>
        <p className="footer-text body-text">
            Copyright &copy; 2025 Kam Yau Shing
        </p>
    </footer>);
}